<template>
  <div>
    <confirm-remove :showRemoveDialog="showRemoveDialog" @confirm="removeRecordTemplate" @close="showRemoveDialog = false"></confirm-remove>
    <md-card class="card-container" v-if="isLoaded">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="isEditing ? '修改範本' : '新增範本'"></page-title>
        </div>
        <div class="md-layout-item float-right">
          <md-button v-if="isEditing" class="md-raised md-accent float-right" @click="showRemoveDialog = true">刪除範本</md-button>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
            <md-field>
              <label>內容</label>
              <md-textarea v-model="data.content"></md-textarea>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="$router.back()">返回</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-primary float-right" @click="isEditing ? editRecordTemplate() : createRecordTemplate()">送出</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import ConfirmRemove from '@/components/Shared/ConfirmRemove'
import axios from 'axios'
import urls from '@/urls'

export default {
  data () {
    return {
      isLoaded: false,
      showRemoveDialog: false,
      isEditing: null,
      data: {
        name: null,
        content: null,
        template_group: {
          id: null
        }
      }
    }
  },
  components: {
    PageTitle, ConfirmRemove
  },
  created: async function () {
    this.data.template_group.id = this.$route.params.groupID
    if (this.$route.params.id !== 'add') {
      this.isEditing = await this.$route.params.id
    }
    if (this.isEditing) {
      await this.readRecordTemplate(this.isEditing)
    }
    this.isLoaded = true
  },
  methods: {
    readRecordTemplate: async function (templateID) {
      let req = await axios.get(urls({route: 'record-template', id: templateID}), this.data)
      this.data = req.data.data
    },
    editRecordTemplate: async function () {
      let req = await axios.put(urls({route: 'record-template', id: this.isEditing}), this.data)
      if (req.status === 200) {
        this.$router.back()
      }
    },
    createRecordTemplate: async function () {
      let req = await axios.post(urls({route: 'record-template'}), this.data)
      if (req.status === 201) {
        this.$router.back()
      }
    },
    removeRecordTemplate: async function () {
      let req = await axios.delete(urls({route: 'record-template', id: this.isEditing}))
      if (req.status === 201) {
        this.$router.back()
      }
    }
  }
}
</script>

<style scoped>
textarea {
  min-height: 350px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/RecordTemplate/RecordTemplateEdit.vue